import { render, staticRenderFns } from "./mediationFails.vue?vue&type=template&id=b823d8ec&scoped=true"
import script from "./mediationFails.vue?vue&type=script&lang=js"
export * from "./mediationFails.vue?vue&type=script&lang=js"
import style0 from "./mediationFails.vue?vue&type=style&index=0&id=b823d8ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b823d8ec",
  null
  
)

export default component.exports